<template>
  <div class="product-list-layout">
    <i
      v-show="pagingPayload.pageNo > 1"
      class="el-icon-arrow-left product-list-arrow--left"
      @click="onChangePage('prev')"
    />
    <ProductItem v-for="product in productList" :key="product.id" :product="product" />
    <i
      v-show="pagingPayload.pageNo * 6 < totalCount"
      class="el-icon-arrow-right product-list-arrow--right"
      @click="onChangePage('next')"
    />
  </div>
</template>

<script>
import ProductItem from './components/ProductItem.vue'
import { getZscqProductList } from '@/api/zscq'
export default {
  components: {
    ProductItem
  },
  data() {
    return {
      pagingPayload: {
        pageNo: 1,
        pageSize: 6,
        name: '知识产权'
      },
      productList: [],
      totalCount: 0
    }
  },
  created() {
    this.getProductList()
  },
  methods: {
    onChangePage(type) {
      if (type === 'prev') {
        this.pagingPayload.pageNo--
      } else {
        this.pagingPayload.pageNo++
      }
      this.getProductList()
    },
    getProductList() {
      getZscqProductList(this.pagingPayload).then(res => {
        if (res.data.code !== 0) return
        this.productList = res.data.data.result
        this.totalCount = +res.data.data.totalCount
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list-layout {
  width: 580px;
  height: 560px;
  display: flex;
  flex-wrap: wrap;
  border-top: 1px #eee solid;
  position: relative;

  &:hover {
    .product-list-arrow--left,
    .product-list-arrow--right {
      opacity: 1;
    }
  }

  .product-list-arrow--left,
  .product-list-arrow--right {
    @extend %product-list-arrow;
    transition: all 0.1s;
    opacity: 0;
  }

  .product-list-arrow--left {
    left: 0;
  }

  .product-list-arrow--right {
    right: 0;
  }

  %product-list-arrow {
    height: fit-content;
    margin: auto 10px;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    cursor: pointer;

    &::after {
      content: '';
      width: 30px;
      height: 30px;
      background: rgba(0, 0, 0, 0.05);
      border-radius: 50%;
      position: absolute;
      top: -5px;
      bottom: 0;
      left: -5px;
      right: 0;
      z-index: -1;
    }
  }
}
</style>
